import React, { useEffect, useState } from 'react'
import { postModificarOtrosParticipantes, postProcedimientoModificar } from '../../../services/PaginaRuta'
import ModalModificarEspecialidadOtrosParticipantes from './ModalModificarEspecialidadOtrosParticipantes'
import ModalModificarSeleccionHonorariosOtrosParticipantes from './ModalModificarSeleccionHonorariosOtrosParticipantes'

const ModalModificarOtrosParticipantes = ({setmodalOnModificarOtrosParticipantes, item,passEliminarOtrosParticipantes}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnModificarEspecialidadOtrosParticipantes, setmodalOnModificarEspecialidadOtrosParticipantes]=useState(false)
  const [modalOnModificarHonorariosOtrosParticipantes, setmodalOnModificarHonorariosOtrosParticipantes]=useState(false)
  const [dataUserOtrosParticipantes, setdataUserOtrosParticipantes]=useState([])

  const [dataChildOtrosModificarEspecialidad, setdataChildOtrosModificarEspecialidad]=useState({
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })

  const [dataChildModificarTipo, setdataChildModificarTipo]=useState({
    codigoTipo:'',
    descripcionTipo:''
  })

  const passChildModificarTipo=(data)=>{
    //console.log(data,'passChildModificarTipo')
    setdataChildModificarTipo(data)
  }

  const passOtrosModificarEspecialidad=(data)=>{
    //console.log(data,'modificar especialidadadad')
    setdataChildOtrosModificarEspecialidad(data)
  }

  const handleOnclickModificarHonorariosOtrosParticipantes=()=>{
    setmodalOnModificarHonorariosOtrosParticipantes(true)
  }

  const handleOnclickModificarEspecialidadOtrosParticipantes=()=>{
    setmodalOnModificarEspecialidadOtrosParticipantes(true)
  }
  const handleCancelarClick =()=>{
    setmodalOnModificarOtrosParticipantes(false)
  }

  const handleSubmitModificarParticipantes=(e)=>{
    e.preventDefault();

    // const bodyModificar={
    //   ProCirCod: "58583",
    //   ProMCDpto: "001      ",
    //   ProEmpCod: "1 ",
    //   PersCod: "00017",
    //   PersNom: "PRUEBAS  HOSVITAL                       ",
    //   PersTip: "06",
    //   PersTipDes: "ANESTESIOLOGO                 ",
    //   PersEsp: "382",
    //   PersNomEP: "UROLOGIA                                                              "
    // }

    const body={
      ProCirCod: e.target.numeroCirugia.value,
      ProMCDpto:usuarioInfo.Sede,
      ProEmpCod:usuarioInfo.Empresa,
      PersCod: e.target.codigoMedico.value,
      PersNom: e.target.nombreMedico.value,
      PersTip: e.target.codigoTipo.value,
      PersTipDes: e.target.descripcionTipo.value,
      PersEsp: e.target.codigoEspecialidad.value,
      PersNomEP: e.target.nombreEspecialidad.value
    }
    postModificarOtrosParticipantes(body).then((res)=>{
      //console.log(res.data,'')
      
      passEliminarOtrosParticipantes(body)
    })
    setmodalOnModificarOtrosParticipantes(false)
  }

  useEffect(()=>{
    const bodyDatosUser = {
      vaProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: item.ProCirCod,
    };
    postProcedimientoModificar(bodyDatosUser).then((res)=>{
      setdataUserOtrosParticipantes(res.data[0])
      console.log(res.data, 'otros participantes modificar')})
    //console.log(item,'otros participantes modificar')

    setdataChildOtrosModificarEspecialidad({
      codigoEspecialidad: item.PersEsp,
      nombreEspecialidad: item.PersNomEP
    })

    setdataChildModificarTipo({
      codigoTipo: item.PersTip,
      descripcionTipo: item.PersTipDes
    })
  },[])
  return (
    <>
      <div
          className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
          id="exampleModalScrollable"
          tabIndex="-1"
          aria-labelledby="exampleModalScrollableLabel"
          aria-hidden="true"
        >
          <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
            <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
              <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
                <h5
                  className="text-xl font-medium leading-normal text-white"
                  id="exampleModalScrollableLabel"
                >
                  Otros Participantes Cirugía
                </h5>
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  X
                </button>
              </div>
              <div className="flex-auto overflow-y-auto relative p-4">
              <form onSubmit={handleSubmitModificarParticipantes}>
                <div >
                  
                    <div className="flex flex-row py-2  text-left">
                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          N° Cirugía
                        </label>
                        <input
                        defaultValue={item.ProCirCod}
                        name='numeroCirugia'
                          autoComplete="off"
                          type="text"
                          disabled={true}
                          //defaultValue={dataUser.ProCirCod}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Número Documento 
                        </label>
                        <input
                        defaultValue={dataUserOtrosParticipantes.MPCedu}
                          autoComplete="off"
                          type="text"
                          disabled={true}
                          //defaultValue={dataUser.MPCedu}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Tipo de Documento
                        </label>
                        <input
                          autoComplete="off"
                          defaultValue={dataUserOtrosParticipantes.MPTDoc}
                          type="text"
                          disabled={true}
                          //defaultValue={dataUser.MPTDoc}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Nombre Paciente
                        </label>
                        <input
                        defaultValue={dataUserOtrosParticipantes.MPNOMC}
                          autoComplete="off"
                          type="text"
                          disabled={true}
                          //defaultValue={dataUser.MPNOMC}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                    </div>
                  
                  <h5
                    className="text-xl font-medium leading-normal text-gray-800 text-center pt-3"
                    id="exampleModalScrollableLabel"
                  >
                    Otros Participantes
                  </h5>
                  <div className="flex py-2 text-left">
                    <div className="w-1/3  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Código
                      </label>
                      <input
                        autoComplete="off"
                        defaultValue={item.PersCod}
                        disabled={true}
                        name='codigoMedico'
                        type="text"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-2/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Nombre
                      </label>
                      <input
                        autoComplete="off"
                        defaultValue={item.PersNom}
                        disabled={true}
                        name='nombreMedico'
                        type="text"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="flex py-1 text-left">
                    <div className="w-1/3  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Especialidad
                      </label>
                      <input
                      onFocus={handleOnclickModificarEspecialidadOtrosParticipantes}
                      defaultValue={dataChildOtrosModificarEspecialidad.codigoEspecialidad}
                      name='codigoEspecialidad'
                        autoComplete="off"
                        type="text"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        readOnly
                      />
                    </div>
                    <div className="w-2/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Nombre
                      </label>
                      <input
                      disabled={true}
                      defaultValue={dataChildOtrosModificarEspecialidad.nombreEspecialidad}
                      name='nombreEspecialidad'
                        autoComplete="off"
                        type="text"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="flex py-2 text-left">
                    <div className="w-1/3  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Tipo 
                      </label>
                      <input
                        onFocus={handleOnclickModificarHonorariosOtrosParticipantes}
                        defaultValue={dataChildModificarTipo.codigoTipo}
                        name='codigoTipo'
                        autoComplete="off"
                        type="text"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        readOnly
                      />
                    </div>
                    <div className="w-2/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Tipos de Honorario
                      </label>
                      <input
                        disabled={true}
                        autoComplete="off"
                        defaultValue={dataChildModificarTipo.descripcionTipo}
                        //disabled={true}
                        name='descripcionTipo'
                        type="text"
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                  <button
                    type="button"
                    onClick={handleCancelarClick}
                    className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                  <button type="submit"
                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                    Guardar
                  </button>
                </div>
              </form>
              </div>
            </div>
          </div>
      </div>
      {modalOnModificarEspecialidadOtrosParticipantes? <ModalModificarEspecialidadOtrosParticipantes setmodalOnModificarEspecialidadOtrosParticipantes={setmodalOnModificarEspecialidadOtrosParticipantes} passOtrosModificarEspecialidad={passOtrosModificarEspecialidad} item={item}/>:null}
      {modalOnModificarHonorariosOtrosParticipantes? <ModalModificarSeleccionHonorariosOtrosParticipantes setmodalOnModificarHonorariosOtrosParticipantes={setmodalOnModificarHonorariosOtrosParticipantes} passChildModificarTipo={passChildModificarTipo}/>:null}
    </>
  )
}

export default ModalModificarOtrosParticipantes